import { SearchAndSelectVehicle } from '@makemydeal/dr-activities-change-vehicle';

export const SelectVehicleContainer = () => {
    return <SearchAndSelectVehicle />;
};
